import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/d9ae94a4995c5873c66959adfb8f68bc.gif")